// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"42bb6767","389":"a03accb4","455":"6eb7947b","857":"8ec35fb0"}[chunkId] + ".chunk.js";
};